export default "__VITE_ASSET__babac40c__"